import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private httpClient: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    const internalUrl = `${environment.deployUrl}assets/i18n/${lang}.json`;

    return this.httpClient.get(internalUrl).pipe(
      catchError(() => {
        console.warn('W4A Schedule meeting:: Cannot fetch internal translations');

        return of({ app_failed: 'true' });
      }),
    );
  }
}
